import React from 'react';

const ProductBenefits = props => {

  return (
    <section className="product-benefits">
      <div className="product-benefits-group">
        <div className="product-benefit-1-tagline">
          Self-expression at its finest
          <p className="product-benefit-subtitle">
            Write your poems in beautiful templates and present them to 
            your audience in the best way possible.
          </p>
        </div>
        <div className="product-benefit-1-image"></div>
        <div className="product-benefit-2-tagline">
          Window to the world of imagination
          <p className="product-benefit-subtitle">
            A community of aspiring photographers waiting to see your creative 
            clicks and get inspired.
          </p>
        </div>
        <div className="product-benefit-2-image"></div>
        <div className="product-benefit-3-tagline">
          Bring the Picasso out of you!
          <p className="product-benefit-subtitle">
            Touch the world through your art. Unlike other social platforms, 
            get the right supportive audience for your art and a better 
            environment to improve.
          </p>
        </div>
        <div className="product-benefit-3-image"></div>
      </div>
    </section>
  )
};

export default ProductBenefits;
